import React, { Component } from 'react'
import Link from 'gatsby-link'

import Overview from '../components/overview/overview'

class IndexPage extends Component {
  render() {
    return (
      <div
        style={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center',
        }}
      >
        <h2>gigantoid</h2>
        <Overview />
        <Link
          style={{
            background: 'transparent',
            border: '1px solid',
            color: '#546e7a',
            cursor: 'pointer',
            margin: '6em 0 0',
            outline: 'none',
            padding: '0.25em 1.5em 0.33em',
            textDecoration: 'none',
          }}
          to="/contact/"
        >
          contact
        </Link>
      </div>
    )
  }
}

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js